export default __webpack_public_path__ + "static/media/eye.896d16ea.svg";